// @owners { team: patients }
import React from 'react';
import { useGetPaymentMethods } from '~shared/queries/query-keys/paymentMethods';
import { AddPaymentMethodButton } from './AddPaymentMethodButton';
import { PaymentMethodDropdown } from './PaymentMethodDropdown';

export type Props = {
  paymentMethodID: number | null | undefined;
  selectPaymentMethodID: (paymentMethodID: number) => void;
};

export const ChoosePaymentMethod = ({ paymentMethodID, selectPaymentMethodID }: Props) => {
  const { paymentMethods } = useGetPaymentMethods();
  let content;

  if (paymentMethods.length > 0) {
    content = (
      <PaymentMethodDropdown
        paymentMethodID={paymentMethodID}
        paymentMethods={paymentMethods}
        selectPaymentMethodID={selectPaymentMethodID}
      />
    );
  } else {
    content = <AddPaymentMethodButton />;
  }

  return content;
};
